import NotificationBellBadgeFill from './NotificationBellBadgeFill';

export default NotificationBellBadgeFill;
